<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view">
		<vs-alert color="danger" :title="$t('Vehicles.VehicletNotFound.Title')" :active.sync="vh_not_found">
			{{
				$t("Vehicles.VehicletNotFound.Text1") +
				" " +
				$route.params.id +
				" " +
				$t("Vehicles.VehicletNotFound.Text2")
			}}
			<span>
				<span>{{ $t("Check") }} </span>
				<router-link :to="{name: 'app-vehicle-list'}" class="text-inherit underline">{{
					$t("Vehicles.ListOfVehicles")
				}}</router-link>
			</span>
		</vs-alert>
		<div id="user-data" v-if="vehicleData">
			<vx-card :title="$t('Information')" class="mb-base" :cardBorder="true" :noShadow="true">
				<div class="vx-row">
					<div class="vx-col flex-1" id="account-info-col-1">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">{{ $t("Routing.Table.Identification") }}</td>
								<td>{{ vehicleData.identification }}</td>
							</tr>
							<tr>
								<td class="font-semibold">{{ $t("Profile") }}</td>
								<td>{{ vehicleData.profile }}</td>
							</tr>
						</table>
					</div>
					<div class="vx-col flex-1" id="account-info-col-2">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">{{ "T. " + this.$t("Vehicles.Service") }}</td>
								<td>{{ vehicleData.max_travel_duration }}</td>
							</tr>
							<tr>
								<td class="font-semibold">{{ $t("Routing.DistanceRoute") + "(Mts)" }}</td>
								<td>{{ vehicleData.max_travel_distance }}</td>
							</tr>
						</table>
					</div>
					<div class="vx-col flex-1" id="account-info-col-2">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">{{ $t("Deposits.Form.StartDeposit") }}</td>
								<td>{{ vehicleData.init_depot_name }}</td>
							</tr>
							<tr>
								<td class="font-semibold">{{ $t("Deposits.Form.EndDeposit") }}</td>
								<td>{{ vehicleData.end_depot_name }}</td>
							</tr>
						</table>
					</div>
					<vx-card :title="$t('MODULE_SOURCE.Costs') | capitalize" :noShadow="true">
						<div class="vx-row">
							<div class="vx-col flex-1" id="account-info-col-1">
								<table>
									<caption></caption>
									<thead>
										<tr>
											<th scope="col"></th>
										</tr>
									</thead>
									<tr>
										<td class="font-semibold">{{ $t("ResourceModule.Costs.Fixed") }}</td>
										<td>{{ vehicleData.costs.fixed }}</td>
									</tr>
								</table>
							</div>
							<div class="vx-col flex-1" id="account-info-col-1">
								<table>
									<caption></caption>
									<thead>
										<tr>
											<th scope="col"></th>
										</tr>
									</thead>
									<tr>
										<td class="font-semibold">{{ $t("ResourceModule.Costs.KilometeOfTravel") }}</td>
										<td>{{ vehicleData.costs.distance }}</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="vx-row">
							<div class="vx-col flex-1" id="account-info-col-2">
								<table>
									<caption></caption>
									<thead>
										<tr>
											<th scope="col"></th>
										</tr>
									</thead>
									<tr>
										<td class="font-semibold">
											{{ "T. " + $t("ResourceModule.Costs.RoutingTime") }}
										</td>
										<td>{{ vehicleData.costs.time }}</td>
									</tr>
								</table>
							</div>
							<div class="vx-col flex-1" id="account-info-col-1">
								<table>
									<caption></caption>
									<thead>
										<tr>
											<th scope="col"></th>
										</tr>
									</thead>
									<tr>
										<td class="font-semibold">{{ $t("ResourceModule.Costs.TimeTraveled") }}</td>
										<td>{{ vehicleData.costs.traveled_hour }}</td>
									</tr>
								</table>
							</div>
						</div>
					</vx-card>
					<div class="vx-col w-full flex mt-base justify-end" id="account-manage-buttons">
						<vs-button
							type="border"
							icon-pack="feather"
							icon="icon-edit"
							class="mr-4"
							color="success"
							:title="windowWidth > 620 ? null : $t('Crud.Update')"
							:size="iconSize"
							:to="{
								name: 'app-vehicle-edit',
								params: {id: $route.params.id},
							}"
							>{{ windowWidth > 620 ? $t("Crud.Update") : null }}
						</vs-button>
						<vs-button
							type="border"
							color="danger"
							icon-pack="feather"
							icon="icon-trash"
							class="mr-4"
							:title="windowWidth > 620 ? null : $t('Crud.Delete')"
							:size="iconSize"
							@click="confirmDeleteRecord"
							>{{ windowWidth > 620 ? $t("Crud.Delete") : null }}
						</vs-button>
						<vs-button
							type="border"
							color="primary"
							icon-pack="feather"
							icon="icon-list"
							:title="windowWidth > 620 ? null : $t('Vehicles.ListOfVehicles')"
							:size="iconSize"
							:to="{name: 'app-vehicle-list'}"
							>{{ windowWidth > 620 ? $t("Vehicles.ListOfVehicles") : null }}
						</vs-button>
					</div>
				</div>
				<vs-divider class="mt-base mb-base"></vs-divider>
				<template lang="html">
					<vs-tabs>
						<vs-tab :label="$t('AdditionalFields') | capitalize" icon-pack="feather" icon="icon-file-plus">
							<vx-card no-shadow card-border class="mb-base mt-base">
								<table
									v-if="
										vehicleData.additional_info &&
										Object.keys(vehicleData.additional_info).length > 0
									"
								>
									<caption></caption>
									<thead>
										<tr>
											<th scope="col"></th>
										</tr>
									</thead>
									<tr v-for="(value, label) in vehicleData['additional_info']" :key="label">
										<td class="font-semibold">{{ label | capitalize }}</td>
										<td>{{ value }}</td>
									</tr>
								</table>
								<vs-alert v-else active class="mb-5" color="primary">
									<span>
										{{ $t("NotAdditionalFields") }}
									</span>
								</vs-alert>
							</vx-card>
						</vs-tab>
						<vs-tab
							:label="$t('Capacity.AssignedCapacities') | capitalize"
							icon-pack="feather"
							icon="icon-box"
							class="mb-base mt-base"
						>
							<assigned-capacity-list
								v-if="capacityIds.length > 0"
								:is-demand="true"
								:is-type-service="true"
								:capacities="vehicleData.capacities"
								:capacityListIds="capacityIds"
								:navbarOptions="false"
								:columns="columnsCapacity"
								:defaultColumns="defaultColumnsCapacity"
							/>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("Capacity.NoAssignedCapacities") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
						<vs-tab
							:label="$t('Skills.AssignedSkills') | capitalize"
							icon-pack="feather"
							icon="icon-award"
							class="mb-base mt-base"
						>
							<assigned-skill-list
								v-if="skillsIds.length > 0"
								:skillListIds="skillsIds"
								:customConfig="skillListConfig"
							/>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("Skills.NoSkillsAssigned") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
						<vs-tab
							:label="$t('AssignedTeams.AssignedTeams') | capitalize"
							icon-pack="feather"
							icon="icon-users"
							class="mb-base mt-base"
						>
							<assigned-teams-list
								v-if="teamsIds.length > 0"
								:teamListIds="teamsIds"
								:customConfig="teamListConfig"
							/>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("AssignedTeams.NoAssignedTeams") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
						<vs-tab
							:label="$t('AssignedBreaks') | capitalize"
							icon-pack="feather"
							icon="icon-calendar"
							class="mb-base mt-base"
						>
							<assigned-break-list
								v-if="breaksIds.length > 0"
								:navbarOptions="false"
								:breakIds="breaksIds"
								:redirect="true"
								:remove="false"
								:configColumns="false"
							/>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("NoAssignedBreaks") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
						<vs-tab
							:label="$t('Frequency.AssignedFrequencies') | capitalize"
							icon-pack="feather"
							icon="icon-radio"
							class="mb-base mt-base"
						>
							<assigned-frequency-list
								v-if="frequencyIds.length > 0"
								:navbarOptions="false"
								:frequencyIds="frequencyIds"
								:redirect="true"
								:remove="false"
								:configColumns="false"
							/>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("Frequency.NoAssignedFrequencies") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
					</vs-tabs>
				</template>
			</vx-card>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import "swiper/dist/css/swiper.min.css";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import AssignedCapacityList from "@/components/capacity/AssignedCapacityList.vue";
import AssignedSkillList from "@/components/skills/AssignedSkillList.vue";
import AssignedTeamsList from "@/components/teams/AssignedTeamsList.vue";
import AssignedBreakList from "@/components/break/list/AssignedBreakList.vue";
import AssignedFrequencyList from "@/components/frequency/list/AssignedFrequencyList.vue";
import moduleCapacity from "@/store/capacity/moduleCapacity.js";
import moduleSkills from "@/store/skills/moduleSkills.js";
import moduleBreaks from "@/store/breaks/moduleBreaks.js";
import moduleTeams from "@/store/teams/moduleTeams.js";

export default {
	components: {
		vSelect,
		swiper,
		swiperSlide,
		AssignedCapacityList,
		AssignedSkillList,
		AssignedTeamsList,
		AssignedBreakList,
		AssignedFrequencyList,
	},
	data() {
		return {
			vehicleData: null,
			vh_not_found: false,
			columnsCapacity: ["name", "description"],
			defaultColumnsCapacity: ["name", "description"],
			skillListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: ["id", "name", "description", "identifier"],
				defaultColumns: ["id", "name", "description", "identifier"],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				navbarOptions: false,
			},
			teamListConfig: {
				columns: ["id", "name", "description"],
				defaultColumns: ["id", "name", "description"],
				actionDropdown: false,
				btnAssig: true,
				navbarOptions: false,
				multiple: false,
			},
		};
	},
	computed: {
		capacityIds() {
			return this.vehicleData["capacities"] && this.vehicleData["capacities"] !== null
				? this.vehicleData["capacities"].map(({capacity_id}) => capacity_id)
				: [];
		},
		skillsIds() {
			return this.vehicleData["skill_id"] && this.vehicleData["skill_id"] !== null
				? this.vehicleData["skill_id"]
				: [];
		},
		teamsIds() {
			return this.vehicleData["team_id"] && this.vehicleData["team_id"] !== null
				? this.vehicleData["team_id"]
				: [];
		},
		breaksIds() {
			return this.vehicleData["break_id"] && this.vehicleData["break_id"] !== null
				? this.vehicleData["break_id"]
				: [];
		},
		frequencyIds() {
			return this.vehicleData["repeat_frequency_id"] && this.vehicleData["repeat_frequency_id"] !== null
				? this.vehicleData["repeat_frequency_id"]
				: [];
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: `${this.$t("VisitPoints.YouAreAboutToDeleteTheVisitPoint")} "${this.vehicleData.identification}"`,
				accept: this.deleteRecord,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			/* Below two lines are just for demo purpose */
			this.$store
				.dispatch("vehicle/deleteById", this.vehicleData.id)
				.then((res) => {
					this.$router.push({name: "app-vehicle-list"});
					this.showDeleteSuccess();
				})
				.catch((err) => {
					if (err.response.status === 404) {
						return;
					}
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Vehicles.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("Vehicles.CellRenderer.DeleteSuccess.Text"),
			});
		},
	},
	created() {
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
		if (!moduleBreaks.isRegistered) {
			this.$store.registerModule("moduleBreaks", moduleBreaks);
			moduleBreaks.isRegistered = true;
		}
		if (!moduleTeams.isRegistered) {
			this.$store.registerModule("moduleTeams", moduleTeams);
			moduleTeams.isRegistered = true;
		}
		const id = parseInt(this.$route.params.id);
		this.openLoading();
		this.$store
			.dispatch("vehicle/findVehiclePaginated", {id: [id]})
			.then((res) => {
				this.vehicleData = res.records[0];
				this.closeLoading();
				return res.records;
			})
			.catch((err) => {
				this.closeLoading();
				if (err.status === 400) {
					this.vh_not_found = true;
					return;
				}
				console.error(err);
			});
	},
	beforeDestroy() {
		this.$store.commit("moduleCapacity/REMOVE_ALL_ASSIGNED_CAPACITY");
		this.$store.commit("moduleSkills/REMOVE_ALL_ASSIGNED_SKILL");
		this.$store.commit("moduleTeams/CLEAN_ASSIGNED_TEAMS");
		this.$store.commit("moduleBreaks/CLEAN_ASSIGNED_BREAKS");
		this.$store.commit("frequency/REMOVE_ALL_ASSIGNED_FREQUENCY");
	},
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}
}
</style>
